import React from 'react';
import { Container, Typography, Box, Button, Grid, Card, CardContent, IconButton, Fade } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import StarIcon from '@mui/icons-material/Star';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PaymentsIcon from '@mui/icons-material/Payments';
import { useNavigate } from 'react-router-dom';
import granmaxBg from '../../assets/images/granmax-bg.png';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Modern Hero Section */}
      <Box
        sx={{
          minHeight: '100vh',
          position: 'relative',
          background: 'linear-gradient(45deg, #1a237e 30%, #283593 90%)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <Box
  sx={{
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: `url(${granmaxBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.2
  }}
/>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Fade in={true} timeout={1000}>
            <Box sx={{ color: 'white', maxWidth: 800, mx: 'auto', textAlign: 'center' }}>
              <Typography 
                variant="h1" 
                sx={{ 
                  fontWeight: 800,
                  fontSize: { xs: '3rem', md: '5rem' },
                  mb: 3,
                  background: 'linear-gradient(45deg, #fff 30%, #e3f2fd 90%)',
                  backgroundClip: 'text',
                  textFillColor: 'transparent',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
              >
                MENTENG RENT
              </Typography>
              <Typography 
                variant="h4" 
                sx={{ 
                  mb: 4,
                  fontWeight: 300,
                  fontSize: { xs: '1.5rem', md: '2.5rem' }
                }}
              >
                Spesialis Rental Blind Van Jabodetabek
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => window.open('https://wa.me/6282122428628?text=Hello%2C%20I%20want%20to%20rent%20a%20GranMax%20BlindVan', '_blank')}
                sx={{
                  px: 6,
                  py: 2,
                  fontSize: '1.2rem',
                  borderRadius: '30px',
                  background: 'linear-gradient(45deg, #ff9800 30%, #ff5722 90%)',
                  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    transition: 'transform 0.3s ease-in-out'
                  }
                }}
              >
                Chat Admin
              </Button>
            </Box>
          </Fade>
          <Box sx={{ textAlign: 'center', mt: 8 }}>
            <IconButton 
              sx={{ 
                color: 'white',
                animation: 'bounce 2s infinite'
              }}
            >
              <ArrowDownwardIcon />
            </IconButton>
          </Box>
        </Container>
      </Box>

      {/* Features Section */}
      <Box sx={{ py: 12, background: '#f8f9fa' }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {[
              {
				icon: <PaymentsIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
				title: 'Harga Terbaik',
				description: 'Mulai dari IDR 3.800.000,- per Bulan'
			  },
			  {
                icon: <DirectionsCarIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
                title: 'Perawatan Rutin Gratis',
                description: 'Melalui Bengkel Rekomendasi'
              },
              {
                icon: <SpeedIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
                title: 'Proses Cepat',
                description: 'Unit dikirim H+1'
              },
              {
                icon: <SecurityIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
                title: 'Persyaratan Mudah',
                description: 'Akta Pendirian, NIB, KTP Direktur'
              },
              {
                icon: <StarIcon sx={{ fontSize: 40, color: '#ff9800' }} />,
                title: 'Kepuasan Layanan',
                description: 'Direkomendasikan oleh Pelanggan'
              }
            ].map((feature, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card 
                  sx={{ 
                    height: '100%',
                    borderRadius: 4,
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 12px 20px rgba(0,0,0,0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 4 }}>
                    {feature.icon}
                    <Typography variant="h6" sx={{ mt: 2, fontWeight: 600 }}>
                      {feature.title}
                    </Typography>
                    <Typography color="text.secondary" sx={{ mt: 1 }}>
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

     {/* Stats Section */}
	<Box sx={{ py: 12, background: 'linear-gradient(45deg, #1a237e 30%, #f44336 90%)', color: 'white' }}>
	<Container maxWidth="lg">
    <Grid 
      container 
      spacing={4} 
      sx={{ 
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center'
      }}
		>
      {[
        { number: '20+', label: 'GranMax Units' },
        { number: '500+', label: 'Regular Clients' },
        { number: '24/7', label: 'Support Available' },
        { number: '5⭐', label: 'Service Rating' }
      ].map((stat, index) => (
        <Grid item xs={6} md={3} key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
            {stat.number}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 300 }}>
            {stat.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>

      {/* CTA Section */}
      <Box 
        sx={{ 
          py: 12,
          background: `url(${granmaxBg})`,
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.7)'
          }
        }}
      >
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2, textAlign: 'center', color: 'white' }}>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 700 }}>
            Pesan Sekarang!
          </Typography>
          <Button
            variant="contained"
            size="large"
			onClick={() => window.open('https://wa.me/6282122428628?text=Hello%2C%20I%20want%20to%20rent%20a%20GranMax%20BlindVan', '_blank')}
            sx={{
              px: 6,
              py: 2,
              fontSize: '1.2rem',
              borderRadius: '30px',
              background: 'linear-gradient(45deg, #ff9800 30%, #ff5722 90%)',
              '&:hover': {
                transform: 'scale(1.05)',
                transition: 'transform 0.3s ease-in-out'
              }
            }}
          >
            Chat Admin
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;